import React from 'react';
import PropTypes from 'prop-types';

import history from '../../core/history';

import { MenuItem } from 'react-bootstrap';

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

function MenuItemLink(props) {
  const { to, children, onClick } = props;

  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
    }

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
      return;
    }

    if (event.defaultPrevented === true) {
      return;
    }

    event.preventDefault();
    history.push(to);
  };

  return <MenuItem href={to} {...props} onClick={handleClick}>{children}</MenuItem>;
}

MenuItemLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node,
  onClick: PropTypes.any,
};

export default MenuItemLink;
